export const mapRecordingFromRest = raw => ({
  id: raw._id,
  eventId: raw.event_id,
  created: raw.created,
  description: raw.description,
  isMainEventRecording: raw.is_main_event_recording,
  eventVisible: raw.event_visible,
  expirationDate: raw.expiration_date,
  event: {
    title: raw.event?.title,
    startDate: raw.event?.start_date,
    endDate: raw.event?.end_date,
  },
  availableFiles: (raw.available_files || []).map(file => ({
    fileId: file.file_id,
    format: file.format,
    downloadAvailable: file.download_available,
    path: file.path,
    downloadStatus: file.download_status,
  })),
});
